module.exports = __webpack_public_path__ + "static/media/use7.ca12bb9f.jpg";